import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ThemeColorVariable, ThemeSpaceVariable, } from '@caspeco/casper-ui-library.base-ui.theme';
import { Box, Button, Stack, useStyleConfig } from '@chakra-ui/react';
import { format } from 'date-fns';
export const DatePickerDateCell = ({ gridColumn, gridRow, gridIndex, day, handleDateChange, variant, isDisabled, isStrikeThrough, hasBlueDot, hasYellowDot, hasGreenDot, hasGreyDot, hasRedDot, selectWeek, isHoliday, }) => {
    const styles = useStyleConfig('DateCell', { variant });
    const weekStyles = useStyleConfig('DateCellWeek', { variant });
    const isSelectedVariant = (variant === 'selectedDay' ||
        variant === 'startDateRange' ||
        variant === 'endDateRange') &&
        !selectWeek;
    const dot = {
        borderRadius: '50%',
        border: isSelectedVariant ? 'solid 1.5px white' : '',
        width: isSelectedVariant ? '7.5px' : '6px',
        height: isSelectedVariant ? '7.5px' : '6px',
    };
    const isLastDayOfWeek = gridIndex % 7 === 6;
    const handleOnClick = () => {
        if (!isDisabled && !isStrikeThrough) {
            handleDateChange(day);
        }
    };
    const selectWeekButtonStyle = selectWeek && variant === 'selectedDay' && isLastDayOfWeek
        ? {
            borderTopRightRadius: '10px',
            borderBottomRightRadius: '10px',
        }
        : {};
    return (_jsx(_Fragment, { children: _jsxs(Button, { __css: selectWeek ? weekStyles : styles, type: "button", sx: selectWeekButtonStyle, variant: variant, isDisabled: isDisabled || isStrikeThrough, onClick: handleOnClick, gridColumn: gridColumn, gridRow: gridRow, display: "flex", "data-testid": "date-picker-date-cell", children: [_jsx(Box, { "data-testid": isHoliday ? 'holiday' : undefined, sx: { color: isHoliday ? ThemeColorVariable.Error : 'inherit' }, children: format(day, 'd') }), isStrikeThrough && _jsx("span", {}), _jsxs(Stack, { position: "absolute", bottom: ThemeSpaceVariable.XSmall, direction: "row", spacing: ThemeSpaceVariable.XSmall, children: [hasBlueDot && (_jsx(Box, { sx: {
                                ...dot,
                                backgroundColor: ThemeColorVariable.Info,
                            } })), hasGreenDot && (_jsx(Box, { sx: {
                                ...dot,
                                backgroundColor: ThemeColorVariable.Success,
                            } })), hasYellowDot && (_jsx(Box, { sx: {
                                ...dot,
                                backgroundColor: ThemeColorVariable.Warning,
                            } })), hasGreyDot && (_jsx(Box, { sx: {
                                ...dot,
                                backgroundColor: ThemeColorVariable.Neutral,
                            } })), hasRedDot && (_jsx(Box, { sx: {
                                ...dot,
                                backgroundColor: ThemeColorVariable.Error,
                            } }))] })] }) }));
};
//# sourceMappingURL=datepicker-date-cell.js.map